import { Injectable } from "@angular/core";
import { HttpRequest, HttpHeaders, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { AuthService } from '../services/auth.service'
import { catchError, switchMap } from "rxjs/operators";
import { Router } from '@angular/router';
import { NotificationService } from "src/app/notification.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  returnUrl;
  returnParams;

  constructor(
    private authService: AuthService,
    private tostr: NotificationService,
    private router: Router
  ) { }

  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    if(!token) {
      if(req.url.includes('view-contract')) return req.clone({responseType: 'blob'})
      return req
    }
    if(req.url.includes("qlikcloud.com")) {
      let qlikIntegrationID = localStorage.getItem('qlikIntegrationID');
      let jwt_token = localStorage.getItem('webToken')
      const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + jwt_token,
        'qlik-web-integration-id': qlikIntegrationID,
      });
      return req.clone({headers, responseType: 'text', withCredentials: true})
    }
    else if(req.url.includes("view-contract")) {
      return req.clone({ setHeaders: { Authorization: "Bearer " + token }, responseType: 'blob' })
    }
    return req.clone({ setHeaders: { Authorization: "Bearer " + token } });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Add jwt token into headers if available in local
    let token = localStorage.getItem("token");
    // console.log('added token from token interceptor and cloning request')
    request = this.addToken(request, token);
    return next.handle(request).pipe(
      catchError(err => {
        // return throwError(err)
        if (!navigator.onLine || err.status === 0) {
          this.router.navigate(['/server-down']);
          return throwError(err);
        }
        if (err.status === 401) {
          // console.log('TI>>>', err)
          if (err.error.detail && err.error.detail.includes("Token is invalid or expired")) {
            // console.log('refresh token expired (TI)')
            this.authService.logoutUser(true)
            return throwError(err);
          }
          if (err.error.detail && err.error.detail.includes("No active account found with the given credentials")) {
            this.tostr.error(err.error.detail);
            this.authService.logoutUser();
            return throwError(err)
          }
          if (err.error.detail && err.error.detail.includes("Default password is not allowed")) {
            return throwError(err)
          }
          if (err.error.detail && err.error.detail.includes("Your account is blocked")) {
            this.tostr.error(err.error.detail);
            return throwError(err);
          }
          // else{
          //   this.tostr.error(err.error);
          //  }
          return this.handle401Error(request, next)
        }
        else if (err.status == 405) {
          this.tostr.error('Application error');
        } else {
          // console.log(err)
          if (err.error.apnx_error) {
            this.tostr.error(err.error.apnx_error);
          }
          else if (err.error.error) {
            this.tostr.error(err.error.error);
          }
          else if (err.error.detail) {
            this.tostr.error(err.error.detail);
          }
          else {
            this.tostr.error(err.error);
          }
          return throwError(err);
        }
      })
    );
  }

  handle401Error(req: HttpRequest<any>, next: HttpHandler) {
    return this.authService.refreshToken().pipe(
      switchMap((res) => {
        // console.log('401 handelling (TI)')
        let token = res['access']
        localStorage.setItem('token', token);
        return next.handle(this.addToken(req, token));
      })
    );
  }
}
export const TokenInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenInterceptor,
  multi: true,
};
